import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailNotificationComponent from "../../../components/Customer/notifications/DetailNotificationComponent";

const DetailNoticationPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate(-1);
    }

    return <DetailNotificationComponent notificationId={ params.notificationId } shouldRedirect={ () => redirect() } />;
}

export default DetailNoticationPage;